import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { "aria-label": "breadcrumb" }
const _hoisted_2 = { class: "breadcrumb mb-3" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = { class: "container-fluid" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_13 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "flex-grow-1" }
const _hoisted_16 = {
  key: 2,
  class: "row"
}
const _hoisted_17 = { class: "card h-100 workspace-card border-0 shadow-sm" }
const _hoisted_18 = { class: "card-img-top workspace-logo-container" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = {
  key: 1,
  class: "workspace-logo-placeholder d-flex align-items-center justify-content-center"
}
const _hoisted_21 = { class: "card-body d-flex flex-column" }
const _hoisted_22 = ["title"]
const _hoisted_23 = {
  key: 0,
  class: "badge bg-primary ms-2",
  title: "AI Generated Workspace"
}
const _hoisted_24 = { class: "mb-2" }
const _hoisted_25 = { class: "bg-light px-1 rounded" }
const _hoisted_26 = { class: "card-text text-muted small flex-grow-1" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "fst-italic"
}
const _hoisted_29 = { class: "mt-auto" }
const _hoisted_30 = { class: "row g-2 text-center" }
const _hoisted_31 = { class: "col-4" }
const _hoisted_32 = { class: "d-flex flex-column" }
const _hoisted_33 = { class: "h6 mb-0 text-primary" }
const _hoisted_34 = { class: "col-4" }
const _hoisted_35 = { class: "d-flex flex-column" }
const _hoisted_36 = { class: "h6 mb-0 text-success" }
const _hoisted_37 = { class: "col-4" }
const _hoisted_38 = { class: "d-flex flex-column" }
const _hoisted_39 = { class: "h6 mb-0 text-info" }
const _hoisted_40 = { class: "card-footer bg-transparent border-top-0 pt-0" }
const _hoisted_41 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_42 = { class: "text-muted" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 3,
  class: "text-center py-5"
}
const _hoisted_45 = { class: "mt-3" }
const _hoisted_46 = {
  key: 0,
  class: "card-footer bg-light"
}
const _hoisted_47 = { class: "row text-center" }
const _hoisted_48 = { class: "col-md-3 col-6 mb-2 mb-md-0" }
const _hoisted_49 = { class: "d-flex flex-column" }
const _hoisted_50 = { class: "h5 mb-0 text-primary" }
const _hoisted_51 = { class: "col-md-3 col-6 mb-2 mb-md-0" }
const _hoisted_52 = { class: "d-flex flex-column" }
const _hoisted_53 = { class: "h5 mb-0 text-success" }
const _hoisted_54 = { class: "col-md-3 col-6 mb-2 mb-md-0" }
const _hoisted_55 = { class: "d-flex flex-column" }
const _hoisted_56 = { class: "h5 mb-0 text-warning" }
const _hoisted_57 = { class: "col-md-3 col-6" }
const _hoisted_58 = { class: "d-flex flex-column" }
const _hoisted_59 = { class: "h5 mb-0 text-info" }
const _hoisted_60 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0, 0, 0, 0.5)"}
}
const _hoisted_61 = { class: "modal-dialog modal-lg" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = { class: "modal-header" }
const _hoisted_64 = { class: "modal-title" }
const _hoisted_65 = { class: "modal-body" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-md-4" }
const _hoisted_68 = ["src", "alt"]
const _hoisted_69 = {
  key: 1,
  class: "bg-light rounded d-flex align-items-center justify-content-center",
  style: {"height":"200px"}
}
const _hoisted_70 = { class: "col-md-8" }
const _hoisted_71 = { class: "table table-borderless table-sm" }
const _hoisted_72 = { class: "table table-borderless table-sm" }
const _hoisted_73 = { class: "badge bg-primary" }
const _hoisted_74 = { class: "badge bg-success" }
const _hoisted_75 = { class: "badge bg-info" }

import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import apiService from "@/services/apiService";

// Types
interface Workspace {
  _id: string;
  logo: string | null;
  title: string;
  idea: string;
  no_of_lanes: number;
  no_of_modules: number;
  no_of_people: number;
  is_ai_generated: boolean;
}

interface UserInfo {
  _id: string;
  username: string;
  logo: string | null;
}

// Route params

export default /*@__PURE__*/_defineComponent({
  __name: 'UserWorkspaces',
  setup(__props) {

const route = useRoute();
const userId = computed(() => route.params.userId as string);

// Reactive data
const workspaces = ref<Workspace[]>([]);
const userInfo = ref<UserInfo | null>(null);
const selectedWorkspace = ref<Workspace | null>(null);
const isLoading = ref(false);
const error = ref<string | null>(null);
const showModal = ref(false);

// Computed properties
const totalLanes = computed(() =>
  workspaces.value.reduce((sum, ws) => sum + ws.no_of_lanes, 0)
);

const totalModules = computed(() =>
  workspaces.value.reduce((sum, ws) => sum + ws.no_of_modules, 0)
);

const totalPeople = computed(() =>
  workspaces.value.reduce((sum, ws) => sum + ws.no_of_people, 0)
);

// Methods
const loadWorkspaces = async () => {
  if (!userId.value) {
    error.value = "No user ID provided";
    return;
  }

  isLoading.value = true;
  error.value = null;

  try {
    console.log(`Loading workspaces for user: ${userId.value}`);
    const response = await apiService.get(
      `/common/cms/users/${userId.value}/workspaces`
    );

    console.log("API Response:", response);

    // The apiService.get() already extracts the data from the standardized response
    if (Array.isArray(response)) {
      workspaces.value = response;
      console.log(`Loaded ${workspaces.value.length} workspaces`);

      // Also try to get user info for display
      await loadUserInfo();
    } else {
      console.error("Invalid response structure:", response);
      throw new Error(
        `Invalid response format. Expected array, got: ${typeof response}`
      );
    }
  } catch (err: any) {
    console.error("Error loading workspaces:", err);
    error.value =
      err?.response?.data?.message ||
      err?.message ||
      "Failed to load workspaces";
  } finally {
    isLoading.value = false;
  }
};

const loadUserInfo = async () => {
  try {
    // Try to get user info from the users list
    const response = await apiService.get("/common/cms/users");

    // The apiService.get() already extracts the data from the standardized response
    if (Array.isArray(response)) {
      const user = response.find((u: any) => u._id === userId.value);
      if (user) {
        userInfo.value = {
          _id: user._id,
          username: user.username,
          logo: user.logo,
        };
      }
    }
  } catch (err) {
    console.warn("Could not load user info:", err);
    // Non-critical error, continue without user info
  }
};

const viewWorkspaceDetails = (workspace: Workspace) => {
  selectedWorkspace.value = workspace;
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
  selectedWorkspace.value = null;
};

const formatTimeAgo = (objectId: string): string => {
  // Extract timestamp from MongoDB ObjectId (first 8 hex chars = 4 bytes = Unix timestamp)
  const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000;
  const date = new Date(timestamp);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) {
    return "today";
  } else if (diffInDays === 1) {
    return "yesterday";
  } else if (diffInDays < 7) {
    return `${diffInDays} days ago`;
  } else if (diffInDays < 30) {
    const weeks = Math.floor(diffInDays / 7);
    return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
  } else if (diffInDays < 365) {
    const months = Math.floor(diffInDays / 30);
    return `${months} month${months > 1 ? "s" : ""} ago`;
  } else {
    const years = Math.floor(diffInDays / 365);
    return `${years} year${years > 1 ? "s" : ""} ago`;
  }
};

// Lifecycle
onMounted(() => {
  loadWorkspaces();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/registered-users" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Registered Users", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("li", {
          class: "breadcrumb-item active",
          "aria-current": "page"
        }, " User Workspaces ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "mb-1" }, "User Workspaces", -1)),
                (userInfo.value)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_10, [
                      _cache[3] || (_cache[3] = _createTextVNode(" Showing workspaces for user: ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(userInfo.value.username), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_router_link, {
                to: "/registered-users",
                class: "btn btn-outline-secondary btn-sm"
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1),
                  _createTextVNode(" Back to Users ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("div", {
                      class: "spinner-border text-primary",
                      role: "status"
                    }, [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                    ], -1),
                    _createElementVNode("p", { class: "mt-2" }, "Loading user workspaces...", -1)
                  ]))]))
                : (error.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Error:", -1)),
                          _createTextVNode(" " + _toDisplayString(error.value), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-danger",
                          onClick: loadWorkspaces
                        }, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("i", { class: "fa fa-refresh" }, null, -1),
                          _createTextVNode(" Retry ", -1)
                        ]))])
                      ])
                    ]))
                  : (workspaces.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (workspace) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: workspace._id,
                            class: "col-lg-4 col-md-6 col-sm-12 mb-4"
                          }, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                (workspace.logo)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: workspace.logo,
                                      alt: workspace.title,
                                      class: "workspace-logo"
                                    }, null, 8, _hoisted_19))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[10] || (_cache[10] = [
                                      _createElementVNode("i", { class: "fa fa-briefcase fa-2x text-muted" }, null, -1)
                                    ]))]))
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("h6", {
                                  class: "card-title text-truncate",
                                  title: workspace.title
                                }, [
                                  _createTextVNode(_toDisplayString(workspace.title) + " ", 1),
                                  (workspace.is_ai_generated)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [...(_cache[11] || (_cache[11] = [
                                        _createElementVNode("i", { class: "fa fa-robot me-1" }, null, -1),
                                        _createTextVNode("AI ", -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_22),
                                _createElementVNode("div", _hoisted_24, [
                                  _cache[12] || (_cache[12] = _createElementVNode("small", { class: "text-muted" }, "ID:", -1)),
                                  _createElementVNode("code", _hoisted_25, _toDisplayString(workspace._id.slice(-8)), 1)
                                ]),
                                _createElementVNode("p", _hoisted_26, [
                                  (workspace.idea && workspace.idea.trim())
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(workspace.idea), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_28, "No description provided"))
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("span", _hoisted_33, _toDisplayString(workspace.no_of_lanes), 1),
                                        _cache[13] || (_cache[13] = _createElementVNode("small", { class: "text-muted" }, "Lanes", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("span", _hoisted_36, _toDisplayString(workspace.no_of_modules), 1),
                                        _cache[14] || (_cache[14] = _createElementVNode("small", { class: "text-muted" }, "Modules", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("div", _hoisted_38, [
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(workspace.no_of_people), 1),
                                        _cache[15] || (_cache[15] = _createElementVNode("small", { class: "text-muted" }, "People", -1))
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("small", null, [
                                      _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-calendar me-1" }, null, -1)),
                                      _createTextVNode(" Created " + _toDisplayString(formatTimeAgo(workspace._id)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("button", {
                                      class: "btn btn-outline-primary btn-sm",
                                      onClick: ($event: any) => (viewWorkspaceDetails(workspace))
                                    }, [...(_cache[17] || (_cache[17] = [
                                      _createElementVNode("i", { class: "fa fa-eye me-1" }, null, -1),
                                      _createTextVNode(" View ", -1)
                                    ]))], 8, _hoisted_43)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mb-3" }, [
                          _createElementVNode("i", { class: "fa fa-briefcase fa-3x text-muted" })
                        ], -1)),
                        _cache[21] || (_cache[21] = _createElementVNode("h5", { class: "text-muted" }, "No Workspaces Found", -1)),
                        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-muted" }, " This user hasn't created any workspaces yet. ", -1)),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("button", {
                            class: "btn btn-primary me-2",
                            onClick: loadWorkspaces
                          }, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                            _createTextVNode(" Refresh ", -1)
                          ]))]),
                          _createVNode(_component_router_link, {
                            to: "/registered-users",
                            class: "btn btn-outline-secondary"
                          }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                              _createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1),
                              _createTextVNode(" Back to Users ", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]))
            ]),
            (workspaces.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("span", _hoisted_50, _toDisplayString(workspaces.value.length), 1),
                        _cache[23] || (_cache[23] = _createElementVNode("small", { class: "text-muted" }, "Total Workspaces", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("span", _hoisted_53, _toDisplayString(totalLanes.value), 1),
                        _cache[24] || (_cache[24] = _createElementVNode("small", { class: "text-muted" }, "Total Lanes", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("span", _hoisted_56, _toDisplayString(totalModules.value), 1),
                        _cache[25] || (_cache[25] = _createElementVNode("small", { class: "text-muted" }, "Total Modules", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("span", _hoisted_59, _toDisplayString(totalPeople.value), 1),
                        _cache[26] || (_cache[26] = _createElementVNode("small", { class: "text-muted" }, "Total People", -1))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (showModal.value && selectedWorkspace.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("h5", _hoisted_64, " Workspace Details: " + _toDisplayString(selectedWorkspace.value.title), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closeModal,
                  "aria-label": "Close"
                })
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    (selectedWorkspace.value.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: selectedWorkspace.value.logo,
                          alt: selectedWorkspace.value.title,
                          class: "img-fluid rounded"
                        }, null, 8, _hoisted_68))
                      : (_openBlock(), _createElementBlock("div", _hoisted_69, [...(_cache[27] || (_cache[27] = [
                          _createElementVNode("i", { class: "fa fa-briefcase fa-3x text-muted" }, null, -1)
                        ]))]))
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _cache[35] || (_cache[35] = _createElementVNode("h6", null, "Basic Information", -1)),
                    _createElementVNode("table", _hoisted_71, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[28] || (_cache[28] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "ID:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("code", null, _toDisplayString(selectedWorkspace.value._id), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[29] || (_cache[29] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Title:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(selectedWorkspace.value.title), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[30] || (_cache[30] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Idea:")
                          ], -1)),
                          _createElementVNode("td", null, _toDisplayString(selectedWorkspace.value.idea || "No description provided"), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[31] || (_cache[31] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "AI Generated:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(
                            selectedWorkspace.value.is_ai_generated
                              ? 'badge bg-success'
                              : 'badge bg-secondary'
                          )
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass([
                              selectedWorkspace.value.is_ai_generated
                                ? 'fa fa-robot'
                                : 'fa fa-user'
                            , "me-1"])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(selectedWorkspace.value.is_ai_generated
                              ? "Yes (AI Generated)"
                              : "No (Manual)"), 1)
                            ], 2)
                          ])
                        ])
                      ])
                    ]),
                    _cache[36] || (_cache[36] = _createElementVNode("h6", null, "Statistics", -1)),
                    _createElementVNode("table", _hoisted_72, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[32] || (_cache[32] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Lanes:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_73, _toDisplayString(selectedWorkspace.value.no_of_lanes), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[33] || (_cache[33] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "Modules:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_74, _toDisplayString(selectedWorkspace.value.no_of_modules), 1)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[34] || (_cache[34] = _createElementVNode("td", null, [
                            _createElementVNode("strong", null, "People:")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_75, _toDisplayString(selectedWorkspace.value.no_of_people), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closeModal
                }, " Close ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})